import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ObjectJoinPipe } from './object-join.pipe';

@NgModule({
  declarations: [ObjectJoinPipe],
  imports: [CommonModule],
  exports: [ObjectJoinPipe]
})
export class ObjectJoinModule {}
